import styled from 'styled-components'

import { Input as DefaultInput } from 'components/FormFields'

export const Input = styled(DefaultInput)`
	height: 40px;
	text-align: right;
	max-width: 120px;
	width: 100%;
	min-width: 90px;
	/* Input wrapper has bottom margin */
	margin: 0 0 0 auto;
	z-index: 2;
`
